var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { TrackingElement } from '@sumup/collector';
import styled from '../../../../styles/styled';
const baseStyles = () => css `
  height: auto;
  justify-self: flex-start;
  overflow-y: auto;
  width: 100%;

  > li {
    list-style-type: none;
  }
`;
const StyledList = styled('ul')(baseStyles);
const TRACKING_ELEMENT = 'navList';
export function NavList(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(TrackingElement, Object.assign({ name: TRACKING_ELEMENT }, { children: _jsx(StyledList, Object.assign({}, props, { role: "list" }, { children: children })) })));
}
